import styled from 'styled-components';

export const PageContainer = styled.div`
  flex: 1;
  width: 100%;
`;
